import { onAuthStateChanged } from "firebase/auth";
import { Navigate, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Container, Box } from "@mui/material";
import { auth } from "../services/firebase";
import LoadingCircle from "./LoadingCircle";

const ProtectedRoutes = ({ children }) => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
        setLoading(false)
      } else {
        setUser(currentUser)
        navigate("/Login")
      }
    })

    return () => unsubscribe()
  }, [user])

  useEffect(() => {
    if (!user) {
      return <Navigate to="/login" />;
    }
  }, [])

  

  return (
    <Container
      component="main"
      maxWidth={false}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {
          loading ? 
          <></>
          :
          <div>
            {children}
          </div>
        }
      </Box>
    </Container>
  );
};

export default ProtectedRoutes;
